import { Link, useMatches } from "react-router-dom";

export function useBreadcrumbs(): Array<{ label: string; path: string }> {
  const matches = useMatches();

  return matches
    .filter((match) => typeof match.handle === "object" && match.handle !== null)
    .map((match) => ({
      label: String((match.handle as { breadcrumb?: string }).breadcrumb ?? ""),
      path: match.pathname,
    }))
    .filter((item) => item.label.length > 0);
}

export function BreadcrumbTrail() {
  const breadcrumbs = useBreadcrumbs();

  return (
    <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-2 text-sm">
      {breadcrumbs.map((item, index) => {
        const isLast = index === breadcrumbs.length - 1;

        return (
          <span key={item.path} className="flex items-center gap-2">
            {index > 0 ? <span className="text-muted-foreground">/</span> : null}
            {isLast ? (
              <span className="font-medium text-foreground">{item.label}</span>
            ) : (
              <Link className="text-muted-foreground transition hover:text-foreground" to={item.path}>
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
